import '../../UIComponents/MessageBox/MessageBox.css';
import React, { Component } from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import Spinner from '../../UIComponents/Spinner/Spinner';

import Cookie from 'js-cookie';

class InfoMsgBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: props.message,
      onClose: props.onClose,
      loading: false,
      pUType: props.pUType,
    };
  }

  fileDownload = (documentPath) => {
    this.props.loading(documentPath);
  };

  componentDidMount() {
    const script = document.createElement('script');

    script.src = 'js/modal.js';
    script.async = true;

    document.body.appendChild(script);
    // alert(JSON.stringify(this.state.message.tbody));
  }

  render() {
    const { pUType, onClose, message } = this.state;

    return (
      <>
        <div className='content-wrapper1'>
          <div className='row'></div>
          <div className='modal fade' id='modal2'>
            <div
              className='modal-dialog dataGridModal'
              style={
                pUType === 'All' ||
                pUType === 'Open' ||
                pUType === '' ||
                pUType === 'High'
                  ? { width: '80%' }
                  : { width: 'fitContent' }
              }
            >
              <div className='modal-content '>
                <div
                  className='modal-header'
                  style={{ background: 'rgb(60, 141, 188)', color: '#fff' }}
                >
                  <button
                    type='button'
                    className='close'
                    data-dismiss='modal'
                    aria-label='Close'
                  >
                    <span aria-hidden='true'>×</span>
                  </button>

                  <h3 className='modal-title'>
                    {message.storeName} - {message.type}{' '}
                    <IconButton
                      aria-label='close'
                      onClick={onClose}
                      data-dismiss='modal'
                      style={{ float: 'right' }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </h3>
                </div>
                {this.props.pageLoad ? (
                  <Spinner />
                ) : (
                  <div className='modal-body table-responsive'>
                    {pUType === 'SOD' ||
                    pUType === 'Flows' ||
                    pUType === 'BSU' ? (
                      <table className='table table-bordered table-striped dataGrid'>
                        <thead
                          style={{
                            background: 'rgb(60, 141, 188)',
                            color: '#fff',
                            textAlign: 'center',
                          }}
                        >
                          <tr>
                            {message.thead.map((val) => (
                              <th key={val} style={{ textAlign: 'center' }}>
                                {val}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {message && message.tbody.length > 0
                            ? message.tbody.map((val, index) => {
                                return (
                                  <tr key={index}>
                                    <td>{val.checklistDate}</td>
                                    <td>{val.checklistScore}</td>
                                    <td>{val.handoverStatus}</td>
                                    {pUType === 'BSU' ? (
                                      <td>{val.sportName}</td>
                                    ) : (
                                      ''
                                    )}
                                    <td>{val.userName}</td>
                                    <td
                                      onClick={() =>
                                        this.fileDownload(val.checklistPdf)
                                      }
                                      style={{ cursor: 'pointer' }}
                                    >
                                      {'Click Here'}
                                    </td>
                                  </tr>
                                );
                              })
                            : ''}
                        </tbody>
                      </table>
                    ) : pUType === 'All' || pUType === 'Open' ? (
                      <table className='table table-bordered table-striped dataGrid'>
                        <thead
                          style={{
                            background: 'rgb(60, 141, 188)',
                            color: '#fff',
                            textAlign: 'center',
                          }}
                        >
                          <tr>
                            {message.thead.map((val) => (
                              <th key={val} style={{ textAlign: 'center' }}>
                                {val}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {message && message.tbody
                            ? message.tbody.map((val, index) => {
                                return (
                                  <tr key={index}>
                                    <td style={{ textAlign: 'left' }}>
                                      {val.incidentType}
                                    </td>
                                    <td>{val.alertLevel}</td>
                                    <td>{val.incidentStatus}</td>
                                    <td>{val.incidentDate}</td>
                                    <td>{val.userName}</td>
                                    <td style={{ textAlign: 'left' }}>
                                      {val.incidentDetails}
                                    </td>
                                    <td
                                      onClick={() =>
                                        this.fileDownload(val.incidentPdf)
                                      }
                                      style={{ cursor: 'pointer' }}
                                    >
                                      {'Click Here'}
                                    </td>
                                  </tr>
                                );
                              })
                            : ''}
                        </tbody>
                      </table>
                    ) : (
                      <table className='table table-bordered table-striped dataGrid'>
                        <thead
                          style={{
                            background: 'rgb(60, 141, 188)',
                            color: '#fff',
                            textAlign: 'center',
                          }}
                        >
                          <tr>
                            {message.thead.map((val) => (
                              <th key={val} style={{ textAlign: 'center' }}>
                                {val}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {message && message.tbody.length > 0
                            ? message.tbody.map((val, index) => {
                                return (
                                  <tr key={index}>
                                    <td
                                      style={{
                                        textAlign: 'left',
                                        width: '350px',
                                      }}
                                    >
                                      {val.description}
                                    </td>
                                    <td>{val.priority}</td>
                                    <td>{val.dueDate}</td>
                                    <td>{val.createdDate}</td>
                                    <td>{val.createdBy}</td>
                                    <td>{val.assignedTo}</td>

                                    <td>{val.ncStatus}</td>
                                    <td>{val.source}</td>
                                    <td style={{ textAlign: 'left' }}>
                                      {val.comments}
                                    </td>
                                  </tr>
                                );
                              })
                            : ''}
                        </tbody>
                      </table>
                    )}
                  </div>
                )}
                <div className='modal-footer'>
                  <button
                    type='button'
                    className='btn btn-secondary deca-btn-orange'
                    onClick={onClose}
                    data-dismiss={'modal'}
                  >
                    Ok
                  </button>
                </div>
              </div>

              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
        </div>
      </>
    );
  }
}

export default InfoMsgBox;
